export default {
  // Navigation
  nav: {
    home: 'Home',
    menu: 'Speisekarte',
    about: 'Über uns',
    reservation: 'Reservierung',
    contact: 'Kontakt',
    gallery: 'Galerie',
    menuOpen: 'Menü öffnen',
    menuClose: 'Menü schließen',
    reserveTable: 'Tisch reservieren'
  },

  // Header
  header: {
    call: 'Anrufen',
    openNow: 'Jetzt geöffnet',
    closed: 'Geschlossen'
  },

  // Hero
  hero: {
    title: 'Authentische italienische Küche',
    subtitle: 'Willkommen im Bella Vista',
    description: 'Erleben Sie die Aromen Italiens in München. Frische Zutaten, traditionelle Rezepte und herzliche Gastfreundschaft seit 1985.',
    cta: 'Tisch reservieren',
    ctaSecondary: 'Speisekarte ansehen'
  },

  // USP Bar
  usp: {
    fresh: 'Frische Zutaten',
    freshDesc: 'Täglich frisch vom Markt',
    homemade: 'Hausgemacht',
    homemadeDesc: 'Traditionelle Rezepte',
    since: 'Seit 1985',
    sinceDesc: 'Familientradition'
  },

  // Featured Dishes
  featured: {
    title: 'Unsere Empfehlungen',
    subtitle: 'Entdecken Sie unsere beliebtesten Kreationen',
    viewAll: 'Alle Gerichte ansehen'
  },

  // About Teaser
  aboutTeaser: {
    title: 'Unsere Geschichte',
    subtitle: 'Eine Reise durch Generationen',
    description: 'Gegründet 1985 von der Familie Rossi, bringt Bella Vista das authentische Flair der italienischen Küche nach München. Unsere Leidenschaft für erstklassige Zutaten und traditionelle Rezepte macht jeden Besuch zu einem besonderen Erlebnis.',
    chef: 'Küchenchef',
    learnMore: 'Mehr erfahren'
  },

  // Testimonials
  testimonials: {
    title: 'Das sagen unsere Gäste',
    subtitle: 'Bewertungen von Google & TripAdvisor'
  },

  // Location & Hours
  location: {
    title: 'Besuchen Sie uns',
    subtitle: 'Wir freuen uns auf Ihren Besuch',
    address: 'Adresse',
    hours: 'Öffnungszeiten',
    getDirections: 'Route planen',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
    closedDay: 'Ruhetag'
  },

  // Reservation CTA
  reservationCta: {
    title: 'Reservieren Sie Ihren Tisch',
    description: 'Sichern Sie sich Ihren Platz für ein unvergessliches kulinarisches Erlebnis.',
    cta: 'Jetzt reservieren',
    or: 'oder rufen Sie uns an'
  },

  // Menu Page
  menuPage: {
    title: 'Unsere Speisekarte',
    subtitle: 'Authentische italienische Gerichte',
    filter: 'Filtern',
    all: 'Alle',
    filterDietary: 'Ernährungsfilter',
    vegetarian: 'Vegetarisch',
    vegan: 'Vegan',
    glutenFree: 'Glutenfrei',
    categories: {
      antipasti: 'Antipasti',
      pasta: 'Pasta',
      pizza: 'Pizza',
      secondi: 'Hauptgerichte',
      dolci: 'Desserts',
      beverages: 'Getränke'
    }
  },

  // About Page
  aboutPage: {
    title: 'Über Bella Vista',
    subtitle: 'Tradition trifft Leidenschaft',
    historyTitle: 'Unsere Geschichte',
    historyText1: 'Im Jahr 1985 eröffnete die Familie Rossi ein kleines Restaurant in München mit dem Traum, authentische italienische Küche nach Bayern zu bringen. Was als kleines Familienunternehmen begann, ist heute ein beliebter Treffpunkt für Liebhaber der italienischen Küche.',
    historyText2: 'Drei Generationen später führen wir diese Tradition mit der gleichen Leidenschaft und Hingabe fort. Jedes Gericht erzählt eine Geschichte – von den Rezepten unserer Großmutter bis zu den modernen Kreationen unseres Küchenchefs.',
    valuesTitle: 'Unsere Werte',
    values: {
      quality: 'Qualität',
      qualityDesc: 'Nur die besten Zutaten finden den Weg in unsere Küche.',
      tradition: 'Tradition',
      traditionDesc: 'Authentische Rezepte, weitergegeben durch Generationen.',
      hospitality: 'Gastfreundschaft',
      hospitalityDesc: 'Jeder Gast ist Teil unserer Familie.'
    },
    teamTitle: 'Unser Team',
    teamSubtitle: 'Die Menschen hinter dem Genuss'
  },

  // Reservation Page
  reservationPage: {
    title: 'Tisch reservieren',
    subtitle: 'Wir freuen uns auf Ihren Besuch',
    form: {
      date: 'Datum',
      time: 'Uhrzeit',
      guests: 'Anzahl Gäste',
      guestsPlaceholder: 'Anzahl Personen',
      name: 'Name',
      namePlaceholder: 'Ihr vollständiger Name',
      email: 'E-Mail',
      emailPlaceholder: 'ihre@email.de',
      phone: 'Telefon',
      phonePlaceholder: '+49 123 456789',
      notes: 'Besondere Wünsche',
      notesPlaceholder: 'Allergien, besondere Anlässe, etc.',
      submit: 'Reservierung anfragen',
      person: 'Person',
      persons: 'Personen'
    },
    demoNotice: 'Dies ist eine Demo-Website. Reservierungen werden nicht verarbeitet.',
    success: 'Vielen Dank! Ihre Reservierungsanfrage wurde gesendet.',
    info: {
      title: 'Gut zu wissen',
      items: [
        'Reservierungen werden innerhalb von 2 Stunden bestätigt',
        'Für Gruppen ab 8 Personen kontaktieren Sie uns bitte telefonisch',
        'Stornierungen bitte bis 24h vor dem Termin'
      ]
    }
  },

  // Contact Page
  contactPage: {
    title: 'Kontakt',
    subtitle: 'Wir sind für Sie da',
    form: {
      name: 'Name',
      namePlaceholder: 'Ihr Name',
      email: 'E-Mail',
      emailPlaceholder: 'ihre@email.de',
      subject: 'Betreff',
      subjectPlaceholder: 'Worum geht es?',
      message: 'Nachricht',
      messagePlaceholder: 'Ihre Nachricht an uns...',
      submit: 'Nachricht senden'
    },
    info: {
      address: 'Adresse',
      addressValue: 'Maximilianstraße 45, 80539 München',
      phone: 'Telefon',
      phoneValue: '089 - 987 654 32',
      email: 'E-Mail',
      emailValue: 'info@bella-vista-muenchen.de',
      hours: 'Öffnungszeiten'
    },
    demoNotice: 'Dies ist eine Demo-Website. Nachrichten werden nicht verarbeitet.'
  },

  // Gallery Page
  gallery: {
    title: 'Galerie',
    subtitle: 'Einblicke in unser Restaurant',
    filters: {
      all: 'Alle',
      food: 'Gerichte',
      interior: 'Ambiente',
      events: 'Events',
      team: 'Team'
    },
    lightbox: {
      close: 'Schließen',
      prev: 'Vorheriges Bild',
      next: 'Nächstes Bild'
    }
  },

  // Footer
  footer: {
    description: 'Authentische italienische Küche in München. Frische Zutaten, hausgemachte Pasta und herzliche Gastfreundschaft seit 1985.',
    quickLinks: 'Schnelllinks',
    contact: 'Kontakt',
    hours: 'Öffnungszeiten',
    newsletter: 'Newsletter',
    newsletterDesc: 'Erhalten Sie Neuigkeiten und exklusive Angebote.',
    emailPlaceholder: 'Ihre E-Mail',
    subscribe: 'Anmelden',
    copyright: '© {year} Bella Vista. Alle Rechte vorbehalten.',
    privacy: 'Datenschutz',
    imprint: 'Impressum'
  },

  // Demo Banner
  demo: {
    title: 'Demo-Projekt',
    description: 'Dies ist ein Portfolio-Demoprojekt',
    descriptionShort: 'Portfolio-Demo',
    close: 'Schließen',
    footerText: 'Demo-Projekt von'
  },

  // Cookies
  cookies: {
    title: 'Cookie-Hinweis',
    message: 'Wir verwenden Cookies, um Ihr Erlebnis zu verbessern. Mit der Nutzung stimmen Sie unserer Datenschutzrichtlinie zu.',
    accept: 'Akzeptieren',
    decline: 'Ablehnen'
  },

  // Common
  common: {
    loading: 'Wird geladen...',
    error: 'Ein Fehler ist aufgetreten',
    readMore: 'Mehr erfahren',
    backToTop: 'Nach oben',
    price: 'Preis',
    from: 'ab'
  },

  // Privacy Page
  privacy: {
    title: 'Datenschutzerklärung',
    lastUpdated: 'Zuletzt aktualisiert: Januar 2025'
  },

  // Imprint Page
  imprint: {
    title: 'Impressum',
    operator: 'Betreiber',
    contact: 'Kontakt',
    legal: 'Rechtliche Hinweise',
    demoNotice: 'Dies ist eine Demo-Website für Portfolio-Zwecke. Bella Vista ist ein fiktives Restaurant.'
  }
};
